import { ITaskTreatment } from "../../../util/varibles/interface";
import styles from "../style.module.scss";
import TaskName from "./TaskName";

export default function TaskView({ tasks, isLabel = true, isShortLabel }: { isLabel?: boolean, isShortLabel?: boolean, tasks: ITaskTreatment[] }) {
    return <div className={styles.tasks}>
        {isLabel && <div className='mr-[10px]' data-lev='title'>Task:</div>}
        <div data-lev='list'>
            {(tasks || []).map((item: any, i) => <TaskName
                key={`${item.group_id} ${i}`}
                data={item}
                isShortLabel={isShortLabel}
            />)}
        </div>
    </div>
}